import { ActivityEntityName } from '../shared/activity.entity.name';
import { StageCompletionBlocker } from '../tasks/stage.completion.gate';
import { ClaimSubmissionRefusal } from './claim.submission.gate';

export type ClaimValidationResultsType = 'Allow' | 'Warn' | 'Block';

export interface ClaimValidationResult {
    entity: ActivityEntityName;
    valid: boolean;
    messages?: string[];
    resultType?: ClaimValidationResultsType;
}

export interface ClaimValidationResultGroup {
    valid: boolean;
    entities?: ClaimValidationResult[];
    /** The tasks holding the stage when the stage completion gate refuses; listed in place of the entity messages. */
    blockingTasks?: StageCompletionBlocker[];
    /** Everything holding the claim when the claim submission gate refuses, for a dialog to list item by item. */
    claimRefusal?: ClaimSubmissionRefusal;
}

export function invalidClaimResult(message: string) {
    return {
        valid: false,
        messages: [message],
        entity: ActivityEntityName.WorkOrder
    };
}

export function invalidClaimResultGroup(message: string) {
    return {
        valid: false,
        entities: [invalidClaimResult(message)]
    };
}